/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Raffle_Prize_WonInputs */



/**
* | output |
* | --- |
* | "Prize: {name}" |
*
* @param {Raffle_Prize_WonInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_prize_won = /** @type {((inputs: Raffle_Prize_WonInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Prize_WonInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Prix : ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Premio: ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Prêmio: ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Premio: ${i?.name}`)
	return /** @type {LocalizedString} */ (`Prize: ${i?.name}`)
});